import type { Vector2Tuple } from 'three';

import type { PCDData } from '../type';

export const KEYS = {
  STORAGE_PCD_BASE_PATH_LIST: 'STORAGE_PCD_BASE_PATH_LIST',
};

export const PCD_Z_STATS_VERSION = 1;

/** PCD 한 건을 내려받는 데 허용하는 시간입니다. 응답 본문을 다 받을 때까지를 셉니다. */
export const PCD_FETCH_TIMEOUT_MS = 60_000;

export const EMPTY_PCD_DATA: PCDData = {
  pointList: new Float32Array(),
  zRange: [0, 10],
};

export const DEFAULT_Z_RANGE = [-Infinity, Infinity] as Vector2Tuple;
